export default class Ping {
    constructor() {

    }
    ping(url) {
        return new Promise( (resolve, reject)=> {
            var started = new Date().getTime();

            this.makeRequest("GET", url).then( (datums)=> {
                var ended = new Date().getTime();
                var milliseconds = ended - started;
                resolve(milliseconds);
            }).catch( (err) =>{
                reject(-1);
            });
        });
    };

    makeRequest(method, url) {
        return new Promise((resolve, reject) => {
            var xhr = new XMLHttpRequest();
            xhr.open(method, url);
            xhr.timeout = 1000; // time in milliseconds
            xhr.onload = function() {
                if (this.status >= 200 && this.status < 300) {
                    resolve(xhr.response);
                } else {
                    reject({
                        status: this.status,
                        statusText: xhr.statusText
                    });
                }
            };
            xhr.ontimeout =function (e) {
                reject({
                    status: 408,
                    statusText: "timeout"
                });
            };
            xhr.onerror =function ()  {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            };
            xhr.send();
        });
    };
    pingNTime(url, n) {
        var times = times || [];

        // Create a new empty promise 
        var sequence = Promise.resolve();

        for (var i = 0; i < n; i++) {
            sequence = sequence.then( (ms)=> {
                return this.ping(url).then( (ms)=> {
                    times.push(ms);
                }).catch( (ms)=> {
                    times.push(-1);
                });
            })
        }
        sequence = sequence.then((ms) => {
            var sum = times.reduce( (a, b)=> { return a + b; });
            var avg = sum / times.length;
            var fullResults = {
                url: url,
                log: times,
                ms: avg,
            }
            return fullResults;
        })
        return sequence;
    };
    findFastestServer(urls, n) {
        return new Promise((resolve, reject) => {
            var promises = [];
            for (var i = 0; i < urls.length; i++) {
                var url = urls[i];

                promises.push(this.pingNTime(url, 5));
            }
            Promise.all(promises).then((values) => {
                console.log(values); // [3, 1337, "foo"] 

                var fastestServer;

                //order by ping
                values.sort(function (a, b) {
                    return a.ms - b.ms;
                });

                //get lowet ping
                for (var i = 0; i < values.length; i++) {
                    var value = values[i];
                    if (value.ms > 0) {
                        fastestServer = value;
                        break;
                    }
                }
                if (fastestServer) {
                    resolve(fastestServer);
                } else {
                    reject("NoServerFound");
                }

            }).catch((reason) => {
                resolve(reason);
            });
        });
    };




}